import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useOurLossesStore = defineStore('ourLosses', {
    state() {
        return {
            allLosses: [],
            singleLoss: {}
        }
    },
    actions: {
        async getLosses(start, end, searchString = '', isDesc = true) {
            const data = {
                start,
                end,
                search_string: searchString,
                is_desc: isDesc
            }

            this.allLosses = await helper.api('GET', '/our_losses', data)
        },

        async getSingleLoss(lossId) {
            this.singleLoss = await helper.api(
                'GET',
                `/our_losses/${lossId}`,
                {}
            )
        },

        async incrementLossViews(lossId) {
            const data = {
                our_loss_id: lossId
            }

            await helper.api('PATCH', '/our_losses', data)
        }
    }
})
